import {
  isArray,
  isNull,
  isPlainObject,
  isString,
  isUndefined,
  keys,
  mapValues,
  omitBy,
  pickBy
} from "lodash-es";

export function swapDeepProperty(
  source: string,
  destination: string,
  targetObjectOrArray: any
): any {
  if (isArray(targetObjectOrArray)) {
    return targetObjectOrArray.map((x) =>
      swapDeepProperty(source, destination, x)
    );
  }

  if (isPlainObject(targetObjectOrArray)) {
    const ret: Record<string, any> = {};
    keys(targetObjectOrArray).forEach((key) => {
      ret[key] = swapDeepProperty(
        source,
        destination,
        targetObjectOrArray[key]
      );
    });

    swapProperty(source, destination, ret);

    return ret;
  }

  return targetObjectOrArray;
}

export function swapProperty(
  source: string,
  destination: string,
  targetObject: any
): void {
  if (typeof targetObject[source] === "undefined") {
    return;
  }

  const value = targetObject[source];
  delete targetObject[source];
  targetObject[destination] = value;
}

export function omitUndefined(value: Record<string, any>): Record<string, any> {
  return pickBy(value, (x) => {
    return !isUndefined(x);
  });
}
export function omitUndefinedAndNullProperties(
  value: Record<string, any>
): Record<string, any> {
  return pickBy(value, (x) => {
    return !isUndefined(x) && !isNull(x);
  });
}

export function omitFalsyProperties(
  value: Record<string, any>
): Record<string, any> {
  return pickBy(value, (x) => {
    return !!x;
  });
}

export function replaceUndefinedWithNull(value: any): any {
  return mapValues(value, (x) => (isUndefined(x) ? null : x));
}

export function removeUndefinedValues(obj: any): any {
  return omitBy(obj, isUndefined);
}

export function replaceEmptryStringsWithNull<T>(value: any): T {
  return mapValues(value, (x) => (x === "" ? null : x));
}

export function removeNullProperties<T>(value: T): Partial<T> {
  // @ts-ignore [expect-error]: 🐛 There is a null/undefined issue here which could cause bugs! Please fix me.
  return <any>omitBy(value, isNull);
}

export function removeEmptyStringProperties<T>(value: T): Partial<T> {
  return <any>omitBy(<any>value, (x) => isString(x) && x.length === 0);
}
